// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.advanve_oBCNP {
  margin-bottom: 20px;
}
.invoice_zBcob {
  width: 20px;
  height: 18px;
}
.dateWidth_btB1s {
  position: absolute;
  width: 100%;
  top: 0px !important;
}
.historyButton_sPAFt {
  width: 200px;
  height: 75px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  margin-bottom: 30px;
}
.buttontext_N6lj5 {
  font-size: 30px;
  font-weight: 700;
  margin-right: 'auto';
}
.clintDropdownListDiv_rIokv {
  display: flex;
  align-items: center;
}
.clintDropdownListImg_eG_sd {
  width: 24px;
  margin-right: 8px;
}
.clientDropdownListSpan_ZOMdw {
  width: 20px;
}
.clientDropdownListSpan2_Du0JM {
  margin: 0 5px;
}
.closeButton_DzqKv {
  margin-right: 8;
}
.communicatioStatus_omYDb {
  display: block;
}
.editrowTableMargin_pn5k5 {
  margin-bottom: 30px;
  width: 100%;
}
.tables_Xhd5N {
  border-collapse: separate;
  width: 100%;
  border: 1px solid black;
  text-align: center;
}
.thstyle_FkULD {
  text-align: center;
  padding: 0px 10px;
}
.trstyle_dIFOR {
  border: 1px solid black;
}
.tdstyle_g1Zfr {
  text-align: center;
  padding: 0px 10px;
}
.disTdStyle_KuKfR {
  margin-left: 15px;
  text-align: center;
}
.descriptionHight_y4E6u {
  height: 50px !important;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Invoice/Invoicing/Invoice.less"],"names":[],"mappings":"AAAA;EACI,mBAAA;AACJ;AACA;EACI,WAAA;EACA,YAAA;AACJ;AACA;EACI,kBAAA;EACA,WAAA;EACA,mBAAA;AACJ;AACA;EACI,YAAA;EACA,uBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AACJ;AACA;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;AACJ;AACA;EACI,aAAA;EACA,mBAAA;AACJ;AACA;EACI,WAAA;EACA,iBAAA;AACJ;AACA;EACI,WAAA;AACJ;AACA;EACI,aAAA;AACJ;AACA;EACI,eAAA;AACJ;AACA;EACI,cAAA;AACJ;AACA;EACI,mBAAA;EACA,WAAA;AACJ;AAEA;EACI,yBAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;AAAJ;AAEA;EACI,kBAAA;EACA,iBAAA;AAAJ;AAEA;EACI,uBAAA;AAAJ;AAEA;EACI,kBAAA;EACA,iBAAA;AAAJ;AAEA;EACI,iBAAA;EACA,kBAAA;AAAJ;AAGA;EACI,uBAAA;AADJ","sourcesContent":[".advanve {\n    margin-bottom: 20px;\n}\n.invoice {\n    width: 20px;\n    height: 18px;\n}\n.dateWidth {\n    position: absolute;\n    width: 100%;\n    top: 0px !important;\n}\n.historyButton {\n    width: 200px;\n    height: 75px !important;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px;\n    margin-bottom: 30px;\n}\n.buttontext {\n    font-size: 30px;\n    font-weight: 700;\n    margin-right: 'auto';\n}\n.clintDropdownListDiv {\n    display: flex;\n    align-items: center;\n}\n.clintDropdownListImg {\n    width: 24px;\n    margin-right: 8px;\n}\n.clientDropdownListSpan {\n    width: 20px;\n}\n.clientDropdownListSpan2 {\n    margin: 0 5px;\n}\n.closeButton {\n    margin-right: 8;\n}\n.communicatioStatus {\n    display: block;\n}\n.editrowTableMargin {\n    margin-bottom: 30px;\n    width: 100%;\n}\n\n.tables {\n    border-collapse: separate;\n    width: 100%;\n    border: 1px solid black;\n    text-align: center;\n}\n.thstyle {\n    text-align: center;\n    padding: 0px 10px;\n}\n.trstyle {\n    border: 1px solid black;\n}\n.tdstyle {\n    text-align: center;\n    padding: 0px 10px;\n}\n.disTdStyle {\n    margin-left: 15px;\n    text-align: center;\n}\n\n.descriptionHight {\n    height: 50px !important;\n}\n\n@primary-color: #2FB153;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"advanve": `advanve_oBCNP`,
	"invoice": `invoice_zBcob`,
	"dateWidth": `dateWidth_btB1s`,
	"historyButton": `historyButton_sPAFt`,
	"buttontext": `buttontext_N6lj5`,
	"clintDropdownListDiv": `clintDropdownListDiv_rIokv`,
	"clintDropdownListImg": `clintDropdownListImg_eG_sd`,
	"clientDropdownListSpan": `clientDropdownListSpan_ZOMdw`,
	"clientDropdownListSpan2": `clientDropdownListSpan2_Du0JM`,
	"closeButton": `closeButton_DzqKv`,
	"communicatioStatus": `communicatioStatus_omYDb`,
	"editrowTableMargin": `editrowTableMargin_pn5k5`,
	"tables": `tables_Xhd5N`,
	"thstyle": `thstyle_FkULD`,
	"trstyle": `trstyle_dIFOR`,
	"tdstyle": `tdstyle_g1Zfr`,
	"disTdStyle": `disTdStyle_KuKfR`,
	"descriptionHight": `descriptionHight_y4E6u`
};
export default ___CSS_LOADER_EXPORT___;
